import * as React from "react";
import isEmpty from "lodash.isempty";
import { ProfilePictureName } from "../../page-framework/profile-picture-name";
import { SVG } from "../../../component-configuration/svgs";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import { InvestmentSidebarLink } from "./investment-sibar-link";
import { SidebarLinks } from "../profile-details-tab/sidebar-links/sidebar-links";

interface ComponentProps {
  list: Entity;
}

type Props = ComponentProps;

export const SideBar = (props: Props) => {
  const { list: entity } = props;
  if (!entity) {
    return (
      <Container>
        <h4>Company</h4>
      </Container>
    );
  }

  const showLeadership =
    entity?.people &&
    entity?.people?.edges &&
    entity?.people?.edges[0] &&
    !isEmpty(entity?.people?.edges[0].person?.fullName?.trim());

  // mission is not yet in the @radivision/graphql Entity type.
  const mission = (entity as Entity & { mission?: string | null }).mission;

  const entityWebsite = entity?.websiteUrl?.includes("http") ? entity?.websiteUrl : `//${entity?.websiteUrl}`;
  return (
    <Container>
      <h4 className="profile-type">{entity?.hasPortfolio ? "Organization" : "Company"}</h4>
      <h1>{entity?.name}</h1>
      <article>{entity?.tagLine}</article>
      {!isEmpty(mission?.trim()) && (
        <div className="mission">
          <h4>Mission</h4>
          <article>{mission}</article>
        </div>
      )}
      {!isEmpty(entity?.websiteUrl) && (
        <a className="website" rel="noreferrer" href={entityWebsite} target="_blank">
          {SVG.externalLinkAlt}
          <span>{entityWebsite}</span>
        </a>
      )}
      <InvestmentSidebarLink entity={entity} />
      <SidebarLinks subject={entity} />
      {showLeadership && (
        <LeaderShip>
          {entity?.people?.edges?.map((entityLeader: { role?: string; person: any }) => {
            if (isEmpty(entityLeader?.person?.fullName)) return null;
            return (
              <ProfilePictureName
                subject={entityLeader?.person}
                key={`person-${entityLeader?.person?.id}`}
                subtitle={entityLeader.person?.responsibility}
              />
            );
          })}
        </LeaderShip>
      )}
    </Container>
  );
};

const Container = ({ children }) => {
  return <div className="profile-sidebar">{children}</div>;
};

const LeaderShip = ({ children }) => {
  return (
    <div className="company-leadership">
      <h4>Leadership</h4>
      {children}
    </div>
  );
};
